import { NgxLoggerLevel } from 'ngx-logger';

export const environment = {
  production: false,
  apiUrl: 'http://localhost:4200/',
  development: isLocalhostConfiguration(),
  dashboardUrl: 'https://dev.shelter.petszel.com',
  petParentAppUrl: 'https://dev.app.petszel.com/',
  logger: {
    level: NgxLoggerLevel.DEBUG,
    serverLogLevel: NgxLoggerLevel.ERROR,
    disableConsoleLogging: false
  }
};

function isLocalhostConfiguration() {
  return window.location.href.includes('localhost');
}
